import { SYNCABLE_PLATFORM_COST_PROVIDER_IDS } from '../types';
import type { SyncablePlatformCostProviderId } from '../types';

const SYNCABLE_PROVIDER_ID_SET: ReadonlySet<string> = new Set(SYNCABLE_PLATFORM_COST_PROVIDER_IDS);

const isSyncablePlatformCostProviderId = (value: string): value is SyncablePlatformCostProviderId =>
    SYNCABLE_PROVIDER_ID_SET.has(value);

export default isSyncablePlatformCostProviderId;
